import { PhoneFrame, QrCodeMark } from "@/components/marketing";
import type { PaymentFlowScreen } from "../../../../data";

interface FlowScreenProps {
  screen: PaymentFlowScreen;
}

const buttonClass =
  "block rounded-xl bg-primary p-[9px] text-center text-[13px] font-bold text-white";

// What sits beside each payment flow's steps: a phone showing the QR or the
// staff entry form, or (for online selling) a small shop + store -> Fydo ->
// one customer diagram.
const FlowScreen = ({ screen }: FlowScreenProps) => {
  switch (screen.kind) {
    case "diagram":
      return (
        <div className="grid justify-items-center gap-2.5 text-center font-bold">
          <span className="rounded-[14px] border-2 border-primary bg-white px-[18px] py-2.5 text-base">
            {screen.sources[0]}
          </span>
          <b aria-hidden="true" className="text-base">
            +
          </b>
          <span className="rounded-[14px] border-2 border-primary bg-white px-[18px] py-2.5 text-base">
            {screen.sources[1]}
          </span>
          <i
            aria-hidden="true"
            className="h-[22px] w-[3px] bg-[repeating-linear-gradient(180deg,var(--primary)_0_5px,transparent_5px_9px)]"
          />
          <em className="rounded-full bg-brand-gradient px-[30px] py-2.5 text-[1.3rem] font-extrabold text-white not-italic">
            {screen.hub}
          </em>
          <i
            aria-hidden="true"
            className="h-[22px] w-[3px] bg-[repeating-linear-gradient(180deg,var(--primary)_0_5px,transparent_5px_9px)]"
          />
          <strong className="text-base text-primary">{screen.result}</strong>
        </div>
      );
    case "qr":
      return (
        <PhoneFrame contentClassName="grid content-center gap-2.5 px-4 pb-9 text-[13px]">
          <span className="text-center text-[15px] font-extrabold">
            {screen.title}
          </span>
          <QrCodeMark className="mx-auto my-1 border-2 border-ink" />
          <span className="text-center text-2xl font-extrabold">
            {screen.amount}
          </span>
          <span className={buttonClass}>{screen.button}</span>
        </PhoneFrame>
      );
    case "form":
      return (
        <PhoneFrame contentClassName="grid content-center gap-2.5 px-4 pb-9 text-[13px]">
          <span className="text-[15px] font-extrabold">{screen.title}</span>
          {screen.fields.map((field) => (
            <span
              key={field.label}
              className="grid gap-0.5 rounded-[10px] border border-line px-2.5 py-2"
            >
              <small className="text-[11px] text-ink-muted">
                {field.label}
              </small>
              <span className="font-bold">{field.value}</span>
            </span>
          ))}
          <span className={buttonClass}>{screen.button}</span>
        </PhoneFrame>
      );
  }
};

export default FlowScreen;
